import pattern from './pattern';
import {
  org_id,
  specialized_subject_id,
  specialized_subject_id_parent,
  specialized_subject_id_child,
  org_id_temp,
  contact_id,
  class_id,
  new_teacher_id,
  class_id_query
} from './formConfigCommon';

const formItems = {
  name: {
    type: 'text',
    label: '名称',
    placeholder: '名称',
    rules: [
      {
        required: true,
        message: '请输入活动名称',
        trigger: 'blur'
      }
    ],
    options: {}
  },
  select: {
    type: 'select',
    label: '活动区域',
    placeholder: '活动区域',
    rules: [{ required: true, message: '请输入活动名称', trigger: 'change' }],
    options: {
      select: [
        {
          value: 'shanghai',
          label: '区域一'
        },
        {
          value: 'beij',
          label: '区域二'
        }
      ]
    }
  },
  date: {
    type: 'date',
    label: '日期',
    placeholder: '日期',
    rules: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    options: {}
  }
};

const buildingFormItem = {
  name: {
    type: 'text',
    label: '教学楼名称',
    placeholder: '请填写教学楼名称',
    rules: [
      {
        required: true,
        message: '请填写教学楼名称',
        trigger: 'blur'
      }
    ]
  },
  total_floor: {
    type: 'text',
    label: '总楼层',
    placeholder: '请填写总楼层',
    rules: [
      {
        message: '请填写正确的总楼层',
        trigger: 'blur',
        pattern: pattern.number
      }
    ]
  },
  classroom_count: {
    type: 'text',
    label: '教室数量',
    placeholder: '请填写教室数量',
    rules: [
      {
        message: '请填写正确的教室数量',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {}
  },
  position: {
    type: 'text',
    label: '位置',
    placeholder: '请填写位置',
    rules: [
      {
        message: '请填写位置',
        trigger: 'blur'
      }
    ],
    options: {}
  }
};

const roomFormItem = {
  building_id: {
    type: 'select',
    label: '教学楼',
    labelKey: 'building_name',
    placeholder: '请选择教学楼',
    rules: [
      {
        required: true,
        message: '请选择教学楼',
        trigger: 'change'
      }
    ],
    options: {
      select: [],
      valueKey: 'id',
      labelKey: 'name',
      filterable: true,
      itemSpan: 12
    }
  },
  name: {
    type: 'text',
    label: '教室名称',
    placeholder: '请填写教室名称',
    rules: [
      {
        required: true,
        message: '请填写教室名称',
        trigger: 'blur'
      }
    ],
    options: {
      itemSpan: 12
    }
  },
  sort_number: {
    type: 'text',
    label: '教室排序',
    placeholder: '请填写教室排序',
    options: {
      itemSpan: 12
    }
  },
  floor: {
    type: 'text',
    label: '楼层',
    placeholder: '请填写楼层',
    rules: [
      {
        trigger: 'blur',
        validator(rule, value, callback) {
          if (pattern.number.test(value)) {
            const curItem = this.formKeys.building_id.options.select.filter(
              item => item.id === this.formData.building_id
            );
            if (curItem && curItem.length && curItem[0].building_floor && curItem[0].building_floor < value) {
              callback(new Error(`教室楼层不能大于教学楼楼层（${curItem[0].building_floor}）！`));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      }
    ],
    options: {
      paramsKeys: ['building_id'],
      itemSpan: 12
    }
  },
  specialized_subject_id: {
    type: 'select',
    label: '属性',
    labelKey: 'specialized_subject_full_name',
    placeholder: '请选择教室属性',
    options: {
      select: [],
      valueKey: 'id',
      labelKey: 'full_name',
      filterable: true,
      itemSpan: 12
    }
  },
  code: {
    type: 'text',
    label: '教室编号',
    placeholder: '请填写教室编号',
    rules: [
      {
        trigger: 'blur',
        message: '请填写教室编号'
      }
    ],
    options: {
      itemSpan: 12
    }
  },
  has_multimedia_equipment: {
    type: 'radio',
    label: '是否有多媒体',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '有'
        },
        {
          id: false,
          name: '没有'
        }
      ],
      label: 'name',
      key: 'id',
      itemSpan: 12
    }
  },
  // activate_status: {
  //   type: 'radio',
  //   label: '状态',
  //   rules: [
  //     {
  //       required: true,
  //       message: '请选择状态',
  //       trigger: 'change'
  //     }
  //   ],
  //   options: {
  //     radios: [
  //       {
  //         id: true,
  //         name: '启用'
  //       },
  //       {
  //         id: false,
  //         name: '禁用'
  //       }
  //     ],
  //     label: 'name',
  //     key: 'id',
  //     itemSpan: 12
  //   }
  // },
  seat_num: {
    type: 'text',
    label: '座位数',
    placeholder: '请填写座位数',
    rules: [
      {
        message: '请填写座位数',
        trigger: 'blur',
        pattern: pattern.number
      }
    ]
  },
  description: {
    type: 'text',
    label: '教室描述',
    placeholder: '请填写教室描述',
    options: {
      type: 'textarea',
      rows: 5,
      itemSpan: 12
    }
  },
  picture_url: {
    type: 'slot',
    label: '图片',
    placeholder: '请上传教室图片',
    options: {
      itemSpan: 12
    }
  }
};
// 级别新增表单
const gradeFormItem = {
  name: {
    type: 'text',
    label: '级别名称',
    placeholder: '请填写级别名称',
    rules: [
      {
        required: true,
        message: '请填写级别名称',
        trigger: 'blur'
      }
    ]
  },
  org_id,
  specialized_subject_id: {
    ...specialized_subject_id,
    options: {
      ...specialized_subject_id.options,
      paramsKeys: ['org_id']
    }
  },
  class_size: {
    type: 'text',
    label: '班级人数',
    placeholder: '请填写班级人数',
    rules: [
      {
        required: true,
        message: '请填写正确的班级人数',
        trigger: 'blur',
        pattern: pattern.integer
      }
    ],
    options: {
      inputSlot: [
        {
          value: '人'
        }
      ]
    }
  },
  single_class_price: {
    type: 'text',
    label: '单节课费',
    placeholder: '请填写单节课费',
    rules: [
      {
        required: true,
        message: '请填写正确的单节课费',
        trigger: 'blur',
        pattern: pattern.positiveDecimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  single_class_duration: {
    type: 'text',
    label: '单节时长',
    placeholder: '请填写单节时长',
    rules: [
      {
        required: true,
        message: '请填写正确的单节时长',
        trigger: 'blur',
        pattern: pattern.integer
      }
    ],
    options: {
      inputSlot: [
        {
          value: '分钟'
        }
      ]
    }
  },
  activate_status: {
    type: 'radio',
    label: '状态',
    rules: [
      {
        required: true,
        message: '请选择级别状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '启用'
        },
        {
          id: false,
          name: '禁用'
        }
      ],
      label: 'name',
      key: 'id'
    }
  }
};
// 组织架构编辑
const specialFormItem = {
  name: {
    type: 'text',
    label: '名称',
    placeholder: '请填写名称',
    rules: [
      {
        required: true,
        message: '请填写名称',
        trigger: 'blur'
      }
    ]
  },
  code: {
    type: 'text',
    label: '代码',
    placeholder: '请填写代码',
    rules: [
      {
        required: true,
        message: '请填写正确的代码',
        trigger: 'blur'
      }
    ]
  },
  org_id: {
    ...org_id,
    label: '父组织'
  },
  province_code: {
    type: 'slot',
    label: '所属地区',
    labelKey: 'province_name',
    placeholder: '请填写所属地区',
    rules: [
      {
        required: true
      }
    ]
  },
  city_code: {
    type: 'slot',
    labelKey: 'city_name',
    placeholder: '请填写所属城市',
    rules: [
      {
        required: true
      }
    ],
    options: {
      class: 'none'
    }
  },
  remarks: {
    type: 'text',
    label: '备注',
    placeholder: '请填写备注',
    options: {}
  }
};
// 打折理由编辑
const discountFormItem = {
  reason: {
    type: 'text',
    label: '打折理由',
    placeholder: '请填写打折理由',
    rules: [
      {
        required: true,
        message: '请填写打折理由',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 3
    }
  },
  rate: {
    type: 'slot',
    label: '折扣率',
    placeholder: '请填写折扣率',
    rules: [
      {
        message: '请填写正确的折扣率',
        trigger: 'blur',
        pattern: pattern.percent
      }
    ]
  },
  remarks: {
    type: 'text',
    label: '备注',
    placeholder: '请填写备注'
  }
};
// 成员信息编辑
const userFormItem = {
  username: {
    type: 'text',
    label: '用户名',
    placeholder: '请填写用户名',
    rules: [
      {
        required: true,
        message: '用户名必须是字母数字组合',
        trigger: 'blur',
        pattern: pattern.user
      }
    ]
  },
  password: {
    type: 'text',
    label: '登录密码',
    placeholder: '请填写登录密码',
    rules: [
      {
        required: true,
        message: '密码格式错误（6-20位数字或字母）',
        trigger: 'blur',
        pattern: pattern.pwd
      }
    ],
    options: {
      type: 'password'
    }
  },
  job: {
    type: 'select',
    label: '职务',
    placeholder: '请选择职务',
    rules: [
      {
        required: true,
        message: '请选择职务',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  real_name: {
    type: 'text',
    label: '姓名',
    placeholder: '请填写姓名',
    rules: [
      {
        required: true,
        message: '请填写姓名',
        trigger: 'blur'
      }
    ]
  },
  id_card_no: {
    type: 'text',
    label: '身份证号',
    placeholder: '请填写身份证号',
    rules: [
      {
        required: true,
        message: '请填写身份证号',
        trigger: 'blur',
        pattern: pattern.idCard
      }
    ]
  },
  telephone: {
    type: 'text',
    label: '手机号',
    placeholder: '请填写手机号',
    rules: [
      {
        message: '请填写手机号',
        trigger: 'blur',
        pattern: pattern.mobile
      }
    ]
  },
  gender: {
    type: 'select',
    label: '性别',
    placeholder: '请选择性别',
    rules: [
      {
        required: true,
        message: '请选择性别',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  birthday: {
    type: 'date',
    label: '出生日期',
    placeholder: '请选择出生日期',
    rules: [
      {
        required: true,
        message: '请选择出生日期',
        trigger: 'change'
      }
    ],
    options: {
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  },
  email: {
    type: 'text',
    label: 'email',
    placeholder: '请填写email',
    rules: [
      {
        message: '请填写正确的email',
        trigger: 'blur',
        pattern: pattern.email
      }
    ]
  }
};
// 教师表单
const teacherFormItem = {
  username: {
    type: 'text',
    labelKey: 'username',
    label: '用户名',
    placeholder: '请填写用户名',
    rules: [
      {
        required: true,
        message: '请填写正确的用户名',
        pattern: pattern.user,
        trigger: 'blur'
      }
    ],
    options: {
      disabled: true
    }
  },
  real_name: {
    type: 'text',
    labelKey: 'real_name',
    label: '姓名',
    placeholder: '请填写姓名',
    rules: [
      {
        required: true,
        message: '请填写姓名',
        trigger: 'blur'
      }
    ],
    options: {
      disabled: true
    }
  },
  id_card_no: {
    type: 'text',
    label: '身份证号',
    placeholder: '请填写身份证号',
    rules: [
      {
        required: true,
        message: '请填写身份证号',
        trigger: 'blur'
      }
    ],
    options: {
      disabled: true
    }
  },
  telephone: {
    type: 'text',
    label: '手机号',
    placeholder: '请填写手机号',
    rules: [
      {
        message: '请填写正确的手机号',
        trigger: 'blur',
        pattern: pattern.mobile
      }
    ],
    options: {
      disabled: true
    }
  },
  bank: {
    type: 'text',
    label: '开户行',
    placeholder: '请填写开户行',
    rules: [
      {
        required: true,
        message: '请填写开户行',
        trigger: 'blur'
      }
    ]
  },
  bank_card_no: {
    type: 'text',
    label: '银行卡号',
    placeholder: '请填写银行卡号',
    rules: [
      {
        required: true,
        message: '请填写银行卡号',
        trigger: 'blur'
      }
    ]
  },
  education: {
    type: 'select',
    label: '学历',
    placeholder: '请选择学历',
    rules: [
      {
        required: true,
        message: '请选择学历',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  job_title: {
    type: 'select',
    label: '职称',
    placeholder: '请选择职称',
    options: {
      select: [],
      clearable: true
    }
  },
  job_status: {
    type: 'select',
    label: '在职状态',
    placeholder: '请选择在职状态',
    options: {
      select: [],
      clearable: true
    }
  },
  remuneration: {
    type: 'text',
    label: '课酬标准',
    placeholder: '请填写课酬标准',
    rules: [
      {
        message: '请填写正确的课酬标准',
        pattern: pattern.decimalOne,
        trigger: 'blur'
      }
    ],
    options: {
      inputSlot: [
        {
          value: '%'
        }
      ]
    }
  },
  teach_time: {
    type: 'text',
    label: '教龄',
    placeholder: '请填写教龄',
    options: {
      inputSlot: [{ value: '年' }],
      itemSpan: 24
    }
  },
  address: {
    type: 'text',
    label: '住址',
    placeholder: '请填写住址',
    rules: [
      {
        message: '请填写住址',
        trigger: 'blur'
      }
    ],
    options: {
      itemSpan: 24,
      class: 'width-full'
    }
  },
  teacher_icon: {
    type: 'slot',
    label: '头像',
    placeholder: '请上传头像'
  },
  resume: {
    type: 'text',
    label: '简历',
    placeholder: '请填写简历',
    rules: [
      {
        message: '请填写简历',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 6
    }
  }
};

// 教师检索表单
const teacherSearchFormItem = {
  org_id: org_id_temp,
  // username: {
  //   type: 'text',
  //   label: '用户名',
  //   placeholder: '请填写用户名'
  // },
  // real_name: {
  //   type: 'text',
  //   label: '真实姓名',
  //   placeholder: '请填写真实姓名'
  // },
  // id_card_no: {
  //   type: 'text',
  //   label: '身份证号',
  //   placeholder: '请填写身份证号'
  // },
  // telephone: {
  //   type: 'text',
  //   label: '手机号',
  //   placeholder: '请填写手机号'
  // },
  education: {
    type: 'select',
    label: '学历',
    placeholder: '请选择学历',
    options: {
      select: [],
      clearable: true
    }
  },
  job_title: {
    type: 'select',
    label: '职称',
    placeholder: '请选择职称',
    options: {
      select: [],
      clearable: true
    }
  },
  job_status: {
    type: 'select',
    label: '教师状态',
    placeholder: '请选择教师状态',
    options: {
      select: [],
      clearable: true
    }
  },
  contract_type: {
    type: 'select',
    label: '合同类型',
    placeholder: '请选择合同类型',
    options: {
      select: [],
      clearable: true
    }
  },
  contract_status: {
    type: 'select',
    label: '合同状态',
    placeholder: '请选择合同状态',
    options: {
      select: [],
      clearable: true
    }
  },
  contract_date: {
    type: 'date',
    label: '合同时间',
    placeholder: '请选择合同状态',
    options: {
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd',
      itemSpan: 24
    }
  }
};

// 注册用户
const registerUserFormItem = {
  username: {
    type: 'text',
    label: '用户名',
    placeholder: '请填写用户名',
    rules: [
      {
        required: true,
        message: '请填写的用户名',
        trigger: 'blur'
      }
    ]
  },
  password: {
    type: 'slot',
    label: '用户密码',
    placeholder: '请填写用户密码',
    rules: [
      {
        required: true,
        message: '请填写用户密码',
        trigger: 'blur',
        pattern: pattern.pwd
      }
    ],
    options: {
      type: 'password'
    }
  },
  phone: {
    type: 'text',
    label: '手机号',
    placeholder: '请填写手机号',
    rules: [
      {
        required: true,
        message: '请填写手机号',
        trigger: 'blur',
        pattern: pattern.mobile
      }
    ]
  },
  nationality: {
    type: 'text',
    label: '国籍',
    placeholder: '请填写国籍'
  },
  id_card_type: {
    type: 'select',
    label: '证件类型',
    placeholder: '请选择证件类型',
    options: {
      select: [],
      clearable: true
    }
  },
  id_card_no: {
    type: 'text',
    label: '证件号码',
    placeholder: '请填写证件号码'
  },
  real_name: {
    type: 'text',
    label: '真实姓名',
    placeholder: '请填写真实姓名'
  },
  gender: {
    type: 'select',
    label: '性别',
    placeholder: '请选择性别',
    options: {
      select: []
    }
  },
  birthday: {
    type: 'date',
    label: '生日',
    placeholder: '请填写生日',
    options: {
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      itemSpan: 24
    }
  },
  // email: {
  //   type: 'text',
  //   label: '邮箱',
  //   placeholder: '请填写邮箱',
  //   rules: [
  //     {
  //       message: '请填写email',
  //       trigger: 'blur',
  //       pattern: pattern.email
  //     }
  //   ]
  // },
  head_url: {
    type: 'slot',
    label: '用户头像'
  },
  id_card_url: {
    type: 'slot',
    label: '证件照片'
  }
};

const registerUserSearchFormItem = {
  username: {
    type: 'text',
    label: '用户名',
    placeholder: '请填写用户名'
  },
  phone: {
    type: 'text',
    label: '手机号',
    placeholder: '请填写手机号'
  },
  id_card_no: {
    type: 'text',
    label: '证件号码',
    placeholder: '请填写证件号码'
  },
  real_name: {
    type: 'text',
    label: '真实姓名',
    placeholder: '请填写真实姓名'
  }
};

// 注册用户关系
const registerUserRelationsFormItem = {
  name: {
    label: '姓名',
    type: 'text',
    placeholder: '请填写姓名',
    rules: [
      {
        required: true,
        message: '请填写姓名',
        trigger: 'blur'
      }
    ]
  },
  birthday: {
    label: '生日',
    type: 'date',
    placeholder: '请选择生日',
    rules: [
      {
        required: true,
        message: '请选择生日',
        trigger: 'change'
      }
    ],
    options: {
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  },
  school_name: {
    label: '所属学校',
    type: 'text',
    placeholder: '请填写学校',
    rules: [
      {
        required: true,
        message: '请填写学校',
        trigger: 'blur'
      }
    ]
  },
  grade: {
    label: '年级',
    type: 'select',
    placeholder: '请选择年级',
    rules: [
      {
        required: true,
        message: '请选择年级',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  class_name: {
    label: '所属班级',
    type: 'text',
    placeholder: '请填写班级',
    rules: [
      {
        required: true,
        message: '请填写班级',
        trigger: 'blur'
      }
    ]
  },
  id_card_type: {
    label: '证件类型',
    type: 'select',
    placeholder: '证件类型',
    rules: [
      {
        required: true,
        message: '选择证件类型',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  id_card_no: {
    label: '证件号码',
    type: 'text',
    placeholder: '请填写证件号码',
    rules: [
      {
        required: true,
        message: '请填写证件号码',
        trigger: 'blur'
      }
    ]
  },
  gender: {
    label: '性别',
    type: 'select',
    placeholder: '性别',
    rules: [
      {
        required: true,
        message: '请选择性别',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  relation: {
    label: '关系',
    type: 'select',
    placeholder: '请选择关系',
    rules: [
      {
        required: true,
        message: '请选择关系',
        trigger: 'change'
      }
    ],
    options: {
      select: [],
      itemSpan: 12
    }
  },
  often_address: {
    label: '常住地址',
    type: 'slot'
  },
  cohabitation: {
    label: '共居人',
    type: 'slot'
  },
  transfer: {
    label: '主要接送人',
    type: 'slot'
  },
  head_url: {
    type: 'slot',
    label: '用户头像',
    rules: [
      {
        required: true,
        message: '请上传用户头像',
        trigger: 'change'
      }
    ]
  },
  id_card_url: {
    type: 'slot',
    label: '证件照片'
  }
};

const classInfFormItem = {
  name: {
    type: 'text',
    label: '班级名称',
    placeholder: '请填写班级名称',
    rules: [
      {
        required: true,
        message: '请填写班级名称',
        trigger: 'blur'
      }
    ]
  },
  year: {
    type: 'radio',
    label: '所属学年',
    placeholder: '请选择所属学年',
    rules: [
      {
        required: true,
        message: '请选择所属学年',
        trigger: 'change'
      }
    ],
    options: {
      radios: [],
      label: 'label',
      key: 'value'
    }
  },
  term_type: {
    type: 'radio',
    label: '学期类型',
    placeholder: '请选择学期类型',
    rules: [
      {
        required: true,
        message: '请选择学期类型',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          value: 1,
          label: '按季节'
        },
        {
          value: 2,
          label: '上下学期'
        }
      ],
      label: 'label',
      key: 'value'
    }
  },
  term: {
    type: 'radio',
    label: '所属学期',
    placeholder: '请选择所属学期',
    rules: [
      {
        required: true,
        message: '请选择所属学期',
        trigger: 'change'
      }
    ],
    options: {
      radios: [],
      label: 'label',
      key: 'value'
    }
  },
  class_type: {
    type: 'radio',
    label: '课程类型',
    placeholder: '请选择课程类型',
    rules: [
      {
        required: true,
        message: '请选择课程类型',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: 1,
          name: '线上班'
        },
        {
          id: 2,
          name: '线下班'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  org_id: {
    ...org_id,
    options: {
      ...org_id.options,
      itemSpan: 12
    }
  },
  specialized_subject_id: {
    ...specialized_subject_id,
    options: {
      ...specialized_subject_id.options,
      paramsKeys: ['org_id']
    }
  },
  fee_level_id: {
    type: 'slot',
    label: '级别',
    placeholder: '请填写项目级别',
    rules: [
      {
        required: true,
        message: '请填写项目级别',
        trigger: 'blur'
      }
    ],
    options: {
      class: 'border-bottom'
    }
  },
  refund_type: {
    type: 'select',
    label: '退费类型',
    placeholder: '请选择退费类型',
    rules: [
      {
        required: true,
        message: '请选择退费类型',
        trigger: 'change'
      }
    ],
    options: {
      select: [],
      label: 'label',
      key: 'value'
    }
  },
  material_fee_refund_type: {
    type: 'select',
    label: '材料费退费类型',
    placeholder: '请选择材料费退费类型',
    rules: [
      {
        required: true,
        message: '请选择材料费退费类型',
        trigger: 'change'
      }
    ],
    options: {
      select: [],
      label: 'label',
      key: 'value'
    },
    itemSpan: 24
  },
  is_need_mailing: {
    type: 'radio',
    label: '需要邮寄',
    placeholder: '请选择是否需要邮寄',
    rules: [
      {
        required: true,
        message: '请选择是否需要邮寄',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  is_need_access_control: {
    type: 'radio',
    label: '需要门禁',
    placeholder: '请选择是否需要门禁',
    rules: [
      {
        required: true,
        message: '请选择是否需要门禁',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  reserved_count: {
    type: 'text',
    label: '预留人数',
    placeholder: '请填写预留人数',
    rules: [
      {
        required: true,
        message: '请填写正确的预留人数',
        trigger: 'blur',
        pattern: pattern.numberZero
      }
    ],
    options: {
      inputSlot: [
        {
          value: '人'
        }
      ]
    }
  },
  // remuneration: {
  //   type: 'text',
  //   label: '课酬率',
  //   placeholder: '请填写课酬率',
  //   rules: [
  //     {
  //       required: true,
  //       message: '请填写正确的课酬率',
  //       trigger: 'blur',
  //       pattern: pattern.percent
  //     }
  //   ],
  //   options: {
  //     itemSpan: 12,
  //     inputSlot: [
  //       {
  //         value: '%'
  //       }
  //     ]
  //   }
  // },
  class_desc: {
    type: 'text',
    label: '描述',
    placeholder: '请填写班级描述',
    options: {
      type: 'textarea',
      rows: 3
    }
  }
};

const classInfCostFormItem = {
  class_fee: {
    type: 'slot',
    label: '学费',
    placeholder: '自动计算',
    rules: [
      {
        required: true,
        message: '请填写课程次数和课程级别'
      }
    ]
  },
  insurance: {
    type: 'text',
    label: '保险费',
    placeholder: '请填写保险费',
    rules: [
      {
        required: true,
        message: '请填写正确的保险费',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  material_fee: {
    type: 'text',
    label: '材料费',
    placeholder: '请填写材料费',
    rules: [
      {
        required: true,
        message: '请填写正确的材料费',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  food_expenses: {
    type: 'text',
    label: '伙食费',
    placeholder: '请填写伙食费',
    rules: [
      {
        required: true,
        message: '请填写正确的伙食费',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  accompanying_fee: {
    type: 'text',
    label: '陪读费',
    placeholder: '请填写陪读费',
    rules: [
      {
        required: true,
        message: '请填写正确的陪读费',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  hosting_fee: {
    type: 'text',
    label: '托管费',
    placeholder: '请填写托管费',
    rules: [
      {
        required: true,
        message: '请填写正确的托管费',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      inputSlot: [
        {
          value: '元'
        }
      ]
    }
  },
  show_price_detail: {
    type: 'radio',
    label: '明细对外',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  }
};

const holidayFormItem = {
  name: {
    type: 'text',
    label: '假日名称',
    placeholder: '请填写假日名称',
    rules: [
      {
        required: true,
        message: '请填写假日名称',
        trigger: 'blur'
      }
    ]
  },
  year: {
    type: 'select',
    label: '年度',
    placeholder: '请选择年度',
    rules: [
      {
        required: true,
        message: '请选择年度',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  date: {
    type: 'date',
    label: '假期时间',
    placeholder: '请选择时间',
    rules: [
      {
        required: true,
        message: '请选择时间',
        trigger: 'change'
      }
    ],
    options: {
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    }
  }
};

const termFormItem = {
  year: {
    type: 'select',
    label: '学年',
    placeholder: '请选择学年',
    rules: [
      {
        required: true,
        message: '请选择学年',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  term: {
    type: 'select',
    label: '学期',
    placeholder: '请选择学期',
    rules: [
      {
        required: true,
        message: '请选择学期',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  org_id,
  date: {
    type: 'date',
    label: '时间',
    placeholder: '请选择时间',
    rules: [
      {
        required: true,
        message: '请选择时间',
        trigger: 'change'
      }
    ],
    options: {
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    }
  },
  apart_month: {
    type: 'text',
    label: '包含月数',
    placeholder: '请填写包含月数',
    rules: [
      {
        required: true,
        message: '请填写包含月数',
        pattern: pattern.integer,
        trigger: 'change'
      }
    ]
  }
};
const globalRecommendFormItem = {
  sign_up_coming_soon: {
    type: 'text',
    label: '即将开始预约',
    placeholder: '请填写即将开始预约',
    rules: [
      {
        required: true,
        message: '请填写正确的即将开始预约',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          type: 'prepend',
          value: '开始预约前'
        },
        {
          value: '天'
        }
      ]
    }
  },
  sign_up_finish_soon: {
    type: 'text',
    label: '即将结束预约',
    placeholder: '请填写即将结束预约',
    rules: [
      {
        required: true,
        message: '请填写正确的即将结束预约',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          type: 'prepend',
          value: '预约结束前'
        },
        {
          value: '天'
        }
      ]
    }
  },
  sign_up_is_coming_to_end: {
    type: 'text',
    label: '即将结束报名',
    placeholder: '请填写即将结束报名',
    rules: [
      {
        required: true,
        message: '请填写正确的即将结束报名',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          type: 'prepend',
          value: '报名结束前'
        },
        {
          value: '天'
        }
      ]
    }
  },
  class_full_soon: {
    type: 'text',
    label: '即将满班',
    placeholder: '请填写即将满班',
    rules: [
      {
        required: true,
        message: '请填写正确的即将满班',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          type: 'prepend',
          value: '班级剩余名额≤'
        },
        {
          value: '人'
        }
      ]
    }
  }
};
const globalClassTimeFormItem = {
  default_year_by_create_class: {
    type: 'select',
    label: '默认学年',
    placeholder: '请选择默认学年',
    rules: [
      {
        required: true,
        message: '请选择默认学年',
        trigger: 'blur'
      }
    ],
    options: {
      multiple: true,
      select: [],
      label: 'name',
      key: 'id'
    }
  },
  default_term_by_create_class: {
    type: 'slot',
    label: '默认学期',
    placeholder: '请选择默认学期',
    rules: [
      {
        required: true,
        trigger: 'blur',
        validator(rule, values, callback) {
          let isTerm = false;
          let isTermType = false;
          values.map(value => {
            if (value >= 4) isTermType = true;
            else isTerm = true;
            return value;
          });
          if (!isTerm) callback(new Error('至少选择一个所属学期！'));
          if (!isTermType) callback(new Error('至少选择一个学期类型！'));
          callback();
        }
      }
    ]
  },
  default_class_sign_up_date: {
    type: 'date',
    label: '外网报名默认时间',
    placeholder: '请选择外网报名默认时间',
    rules: [
      {
        required: true,
        message: '请选择外网报名默认时间',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      itemSpan: 24
    }
  },
  default_rock_date: {
    label: '默认摇号时间',
    type: 'date',
    placeholder: '请选择默认摇号时间',
    rules: [
      {
        required: true,
        message: '请选择默认摇号时间',
        trigger: 'blur'
      }
    ],
    options: {
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      type: 'datetime'
    }
  },
  default_auto_fill_end_time: {
    label: '默认递补结束时间',
    type: 'date',
    placeholder: '请选择默认递补结束时间',
    rules: [
      {
        required: true,
        message: '请选择默认递补结束时间',
        trigger: 'blur'
      }
    ],
    options: {
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      type: 'datetime'
    }
  },
  replenish_sign_up_time: {
    type: 'date',
    label: '补充报名时间',
    placeholder: '请选择补充报名时间',
    rules: [
      {
        required: true,
        message: '请选择补充报名时间',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      itemSpan: 24
    }
  },
  default_class_start_date: {
    type: 'date',
    label: '默认上课日期',
    placeholder: '请选择默认上课日期',
    rules: [
      {
        required: true,
        message: '请选择默认上课日期',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'date',
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      itemSpan: 24
    }
  },
  replace_class_time: {
    type: 'text',
    label: '替换课时间',
    placeholder: '请填写替换课时间',
    rules: [
      {
        required: true,
        message: '请填写正确的替换课时间',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  },
  interview_valid_time: {
    type: 'text',
    label: '面试有效时间',
    placeholder: '请填写面试有效时间',
    rules: [
      {
        required: true,
        message: '请填写正确的面试有效时间',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  }
};
const globalOtherFormItem = {
  minister_quota: {
    type: 'text',
    label: '部长可超额报名人数',
    placeholder: '请填写部长可超额报名人数',
    rules: [
      {
        required: true,
        message: '请填写正确的部长可超额报名人数',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '人'
        }
      ]
    }
  },
  default_edu_sign_up_expires: {
    type: 'text',
    label: '后台报名有效天数',
    placeholder: '请填写后台报名有效天数',
    rules: [
      {
        required: true,
        message: '请填写正确的后台报名有效天数',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  },
  default_sign_up_expires: {
    type: 'text',
    label: '前台预约有效天数',
    placeholder: '请填写前台预约有效天数',
    rules: [
      {
        required: true,
        message: '请填写正确的前台预约有效天数',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  },
  teacher_contract_expire_soon: {
    type: 'text',
    label: '合同到期提醒',
    placeholder: '请填写合同到期提醒',
    rules: [
      {
        required: true,
        message: '请填写正确的合同到期提醒',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  },
  active_by_class_valid_time: {
    type: 'text',
    label: '激活有效天数',
    placeholder: '请填写激活有效天数',
    rules: [
      {
        required: true,
        message: '请填写正确激活有效天数',
        trigger: 'blur',
        pattern: pattern.number
      }
    ],
    options: {
      inputSlot: [
        {
          value: '天'
        }
      ]
    }
  },
  access_control_info_is_show_submit: {
    type: 'radio',
    label: '前台门禁信息修改 ',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: 1,
          name: '开启'
        },
        {
          id: 0,
          name: '关闭'
        }
      ],
      label: 'name',
      key: 'id'
    }
  }
};
const globalClassQueryFormItem = {
  year: {
    type: 'select',
    placeholder: '请选择学年',
    options: {
      select: []
    }
  },
  term: {
    type: 'select',
    placeholder: '请选择学期',
    options: {
      select: []
    }
  },
  org_id,
  specialized_subject_id,
  class_id: class_id_query
};
// 报名
const enteredFormItem = {
  contact_id,
  real_class_count: {
    type: 'slot',
    label: '实上课次',
    placeholder: '请填写实上课次',
    rules: [
      {
        required: true,
        message: '请填写正确的实上课次',
        trigger: 'blur',
        pattern: pattern.integer
      }
    ]
  },
  discount_reason_id: {
    type: 'select',
    label: '折扣理由',
    placeholder: '请选择折扣理由(可检索)',
    rules: [
      {
        required: true,
        message: '请选择折扣理由',
        trigger: 'change'
      }
    ],
    options: {
      select: [],
      clearable: true,
      valueKey: 'id',
      labelKey: 'reason',
      filterable: true
    }
  },
  discount_rate: {
    type: 'text',
    label: '折扣率',
    placeholder: '请填写折扣率',
    rules: [
      {
        required: true,
        message: '请填写正确的折扣率',
        trigger: 'blur',
        pattern: pattern.percent
      }
    ],
    options: {
      inputSlot: [
        {
          value: '%'
        }
      ]
    }
  },
  sign_up_fee: {
    type: 'slot',
    label: '应付金额',
    placeholder: '根据折扣率和原价计算',
    rules: [
      {
        message: '请填写正确的应付金额',
        trigger: 'blur',
        pattern: pattern.decimal
      }
    ],
    options: {
      disabled: true,
      inputSlot: [
        {
          value: '<span>（元）<del>原价：xxx</del></span>'
        }
      ]
    }
  }
};
// 代课基础信息
const teachBaseFormItem = {
  supply_time: {
    type: 'date',
    label: '请假日期',
    placeholder: '请选择请假日期',
    rules: [
      {
        required: true,
        message: '请选择请假日期',
        trigger: 'change'
      }
    ],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    }
  },
  supply_type: {
    type: 'radio',
    label: '代课类型',
    rules: [
      {
        required: true,
        message: '请选择代课类型',
        trigger: 'change'
      }
    ],
    options: {
      radios: [],
      label: 'label',
      key: 'value'
    }
  },
  class_id,
  class_info: {
    type: 'slot'
  },
  original_teacher_id: {
    type: 'select',
    label: '请假老师',
    labelKey: 'original_teacher_name',
    placeholder: '请选择请假老师',
    rules: [
      {
        required: true,
        message: '请选择请假老师',
        trigger: 'blur'
      }
    ],
    options: {
      select: [],
      valueKey: 'id',
      labelKey: 'real_name',
      paramsKeys: ['class_id']
    }
  },
  new_teacher_id,
  supply_class_count: {
    type: 'text',
    label: '课时数',
    placeholder: '选择请假日期和班级后自动计算',
    rules: [
      {
        required: true,
        message: '请选择班级和请假时间',
        trigger: 'blur',
        pattern: pattern.integer
      }
    ],
    options: {
      disabled: true
    }
  },
  supply_reason: {
    type: 'text',
    label: '请假原因',
    placeholder: '请填写请假原因',
    rules: [
      {
        required: true,
        message: '请填写请假原因',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 3
    }
  }
};
// 资讯相关
const newsFormItem = {
  is_use: {
    type: 'radio',
    label: '是否启用',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  info_type: {
    type: 'select',
    label: '资讯类型',
    placeholder: '请选择资讯类型',
    rules: [
      {
        required: true,
        message: '请选择资讯类型',
        trigger: 'change'
      }
    ],
    options: {
      select: []
    }
  },
  surface_plot: {
    type: 'slot',
    label: '资讯封面',
    placeholder: '请上传资讯封面',
    rules: [
      {
        required: true,
        message: '请上传资讯封面',
        trigger: 'change'
      }
    ]
  },
  title: {
    type: 'text',
    label: '标题名称',
    placeholder: '请填写标题名称',
    rules: [
      {
        required: true,
        message: '请填写标题名称',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 3
    }
  },
  content: {
    type: 'slot',
    label: '详细内容',
    placeholder: '请填写详细内容',
    rules: [
      {
        required: true,
        message: '请填写详细内容',
        trigger: 'blur'
      }
    ],
    options: {
      class: 'content-width-full'
    }
  },
  banner: {
    type: 'slot',
    label: '轮播图',
    rules: [
      {
        message: '请填写详细内容',
        trigger: 'change'
      }
    ]
  },
  is_show: {
    type: 'slot',
    label: '',
    options: {
      class: 'height-0'
    }
  }
};
// 场馆相关
const webFormItem = {
  is_use: {
    type: 'radio',
    label: '是否启用',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  venue_img: {
    type: 'slot',
    label: '场馆图片',
    placeholder: '请上传场馆图片',
    rules: [
      {
        required: true,
        message: '请上传场馆图片',
        trigger: 'change'
      }
    ]
  },
  venue_name: {
    type: 'text',
    label: '场馆名称',
    placeholder: '请填写场馆名称',
    rules: [
      {
        required: true,
        message: '请填写场馆名称',
        trigger: 'blur'
      }
    ]
  },
  content: {
    type: 'slot',
    label: '场馆介绍',
    placeholder: '请填写场馆介绍',
    rules: [
      {
        required: true,
        message: '请填写场馆介绍',
        trigger: 'blur'
      }
    ],
    options: {
      class: 'content-width-full'
    }
  }
};
// 常见问题
const problemFormItem = {
  question: {
    type: 'text',
    label: '问题名称',
    placeholder: '请填写标题名称',
    rules: [
      {
        required: true,
        message: '请填写标题名称',
        trigger: 'blur'
      }
    ]
  },
  answer: {
    type: 'text',
    label: '问题答案',
    placeholder: '请填写问题答案',
    rules: [
      {
        required: true,
        message: '请填写问题答案',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 4
    }
  },
  is_use: {
    type: 'radio',
    label: '是否启用',
    placeholder: '请选择是否启用',
    rules: [
      {
        required: true,
        message: '请选择是否启用',
        trigger: 'blur'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  }
};
// 联系信息
const contactFormItem = {
  org_id,
  specialized_subject_ids: {
    type: 'slot',
    label: '项目',
    labelKey: 'specialized_subject_full_name',
    rules: [
      {
        required: true,
        message: '请填写所属项目',
        trigger: 'change'
      }
    ],
    options: {
      placeholder: '请输入项目关键词并选择',
      type: 'select', // input 还是select类型
      metholdKey: 'special', // 服务器请求接口key
      value: 'id',
      label: 'full_name'
    }
  },
  contact_info: {
    type: 'text',
    label: '联系信息',
    placeholder: '请填写联系信息',
    rules: [
      {
        required: true,
        message: '请填写联系信息',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 4
    }
  }
};
const addContractFormItem = {
  contract_type: {
    type: 'select',
    label: '合同类型',
    placeholder: '请选择合同类型',
    options: {
      select: [],
      clearable: true
    },
    rules: [
      {
        required: true,
        message: '请选择合同类型',
        trigger: 'change'
      }
    ]
  },
  contract_date: {
    type: 'date',
    label: '合同期限',
    placeholder: '请选择合同期限',
    options: {
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd'
      // 'picker-options': {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   }
      // }
    },
    rules: [
      {
        required: true,
        message: '请选择合同期限',
        trigger: 'change'
      }
    ]
  }
};

// 系统消息
const sysMessageFormItem = {
  title: {
    type: 'text',
    label: '公告标题',
    placeholder: '请填写公告标题',
    rules: [
      {
        required: true,
        message: '请填写公告标题',
        trigger: 'blur'
      }
    ]
  },
  content: {
    type: 'slot',
    label: '公告内容',
    placeholder: '请填写公告内容',
    rules: [
      {
        required: true,
        message: '请填写公告内容',
        trigger: 'blur'
      }
    ],
    options: {
      class: 'content-width-full'
    }
  },
  is_notify_popup: {
    type: 'radio',
    label: '提醒方式',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '弹窗'
        },
        {
          id: false,
          name: '非弹窗'
        }
      ],
      label: 'name',
      key: 'id'
    }
  }
};
// 系统公告
const newSannouncementItem = {
  title: {
    type: 'text',
    label: '公告标题',
    placeholder: '请填写标题',
    rules: [
      {
        required: true,
        message: '请填写标题',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 2
    }
  },
  content: {
    type: 'text',
    label: '公告内容',
    placeholder: '请填写详细内容',
    rules: [
      {
        required: true,
        message: '请填写详细内容',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 3
    }
  }
};
// app版本
const appVersionItem = {
  version_number: {
    type: 'text',
    label: '版本号',
    placeholder: '请填写版本号',
    rules: [
      {
        required: true,
        message: '请填写版本号',
        trigger: 'blur'
      }
    ]
  },
  version_code: {
    type: 'text',
    label: '版本代码号',
    placeholder: '请填写版本代码号',
    rules: [
      {
        required: true,
        message: '请填写版本代码号',
        trigger: 'blur'
      }
    ]
  },
  app_type: {
    type: 'select',
    label: '类型',
    placeholder: '请选择类型',
    rules: [
      {
        required: true,
        message: '请选择类型',
        trigger: 'blur'
      }
    ],
    options: {
      select: [],
      class: 'block'
    }
  },
  download_url: {
    type: 'slot',
    label: '包上传',
    placeholder: '请上传包文件'
  },
  update_description: {
    type: 'text',
    label: '更新说明',
    placeholder: '请填写更新说明',
    options: {
      type: 'textarea',
      rows: 3
    }
  }
};
const substituteFormItem = {
  org_id: {
    ...org_id,
    options: {
      ...org_id.options,
      itemSpan: 12
    }
  },
  specialized_subject_id_parent: {
    ...specialized_subject_id_parent,
    options: {
      ...specialized_subject_id_parent.options,
      paramsKeys: ['org_id'],
      itemSpan: 12
    }
  },
  specialized_subject_id: {
    ...specialized_subject_id_child,
    options: {
      ...specialized_subject_id_child.options,
      itemSpan: 12
    }
  },
  class_id: {
    ...class_id_query,
    options: {
      ...class_id_query.options,
      paramsKeys: ['specialized_subject_id'],
      itemSpan: 12
    }
  },
  supply_time: {
    type: 'date',
    label: '请假日期',
    placeholder: '请选择请假日期',
    rules: [
      {
        required: true,
        message: '请选择请假日期',
        trigger: 'change'
      }
    ],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  // apply_teacher_id: {
  //   type: 'select',
  //   label: '请假老师',
  //   labelKey: 'apply_teacher_name',
  //   placeholder: '请选择请假老师',
  //   rules: [
  //     {
  //       required: true,
  //       message: '请选择请假老师',
  //       trigger: 'change'
  //     }
  //   ],
  //   options: {
  //     select: [],
  //     valueKey: 'id',
  //     labelKey: 'name',
  //     postData: ['apply_teacher_id'],
  //     paramsKeys: ['class_id']
  //   }
  // },
  apply_teacher_id: {
    type: 'slot',
    label: '请假老师',
    labelKey: 'apply_teacher_id',
    placeholder: '请选择请假老师',
    rules: [
      {
        required: true,
        message: '请选择请假老师',
        trigger: 'change'
      }
    ]
  },
  class_detail_ids: {
    type: 'slot',
    label: '上课时间',
    rules: [
      {
        required: true,
        message: '请选择上课时间',
        trigger: 'change'
      }
    ]
  },
  substitute_course_number: {
    type: 'slot',
    label: '请假课次',
    labelKey: 'substitute_course_number',
    placeholder: '选择请假日期和班级后自动计算',
    options: {
      itemSpan: 12
    }
  },
  substitute_teacher_id: {
    type: 'autoInput',
    label: '代课老师',
    labelKey: 'substitute_teacher_name',
    placeholder: '请选择代课老师',
    rules: [
      {
        required: true,
        message: '请选择代课老师',
        trigger: 'change'
      }
    ],
    options: {
      type: 'select',
      metholdKey: 'teacher',
      value: 'id',
      label: 'real_name',
      itemSpan: 12
    }
  },
  apply_reason: {
    type: 'text',
    label: '请假原因',
    placeholder: '请填写请假原因',
    options: {
      type: 'textarea',
      rows: 3,
      itemSpan: 12
    }
  }
};
const substituteSearchFormItem = {
  year: {
    type: 'select',
    label: '学年',
    placeholder: '请选择学年',
    options: {
      select: [],
      clearable: true
    }
  },
  term: {
    type: 'select',
    label: '学期',
    placeholder: '请选择学期',
    options: {
      select: [],
      clearable: true
    }
  },
  org_id: {
    ...org_id,
    options: {
      ...org_id.options,
      clearable: true
    },
    rules: [
      {
        required: false
      }
    ]
  },
  specialized_subject_id_parent: {
    ...specialized_subject_id_parent,
    options: {
      ...specialized_subject_id_parent.options,
      paramsKeys: ['org_id'],
      clearable: true
    },
    rules: [
      {
        required: false
      }
    ]
  },
  specialized_subject_id: {
    ...specialized_subject_id_child,
    options: {
      ...specialized_subject_id_child.options,
      clearable: true
    },
    rules: [
      {
        required: false
      }
    ]
  }
};
const applyFormItem = {
  org_id: {
    ...org_id,
    options: {
      ...org_id.options,
      itemSpan: 12
    }
  },
  class_id: {
    ...class_id_query,
    options: {
      ...class_id_query.options,
      paramsKeys: ['org_id'],
      itemSpan: 12
    }
  },
  supply_time: {
    type: 'date',
    label: '替课起止时间',
    placeholder: '请选择替课起止时间',
    rules: [
      {
        required: true,
        message: '请选择替课起止时间',
        trigger: 'change'
      }
    ],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'default-time': ['00:00:00', '23:59:59'],
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  // old_teacher_id: {
  //   type: 'select',
  //   label: '请假老师',
  //   labelKey: 'old_teacher_name',
  //   placeholder: '请选择请假老师',
  //   rules: [
  //     {
  //       required: true,
  //       message: '请选择请假老师',
  //       trigger: 'blur'
  //     }
  //   ],
  //   options: {
  //     select: [],
  //     itemSpan: 12,
  //     valueKey: 'id',
  //     labelKey: 'real_name',
  //     postData: ['old_teacher_name']
  //   }
  // },
  old_teacher_id: {
    type: 'slot',
    label: '原老师',
    labelKey: 'old_teacher_id',
    placeholder: '请选择原老师',
    rules: [
      {
        required: true,
        message: '请选择原教师'
      }
    ],
    options: {
      itemSpan: 12
    }
  },

  replace_course_number: {
    type: 'slot',
    label: '新老师上课课次',
    labelKey: 'substitute_course_number',
    placeholder: '选择起止时间和班级后自动计算',
    // rules: [
    //   {
    //     required: true,
    //     message: '请选择请假老师计算课次'
    //   }
    // ],
    options: {
      itemSpan: 12
    }
  },
  new_teacher_id: {
    type: 'autoInput',
    label: '新老师',
    labelKey: 'new_teacher_name',
    placeholder: '请选择新老师',
    rules: [
      {
        required: true,
        message: '请选择新老师',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'select',
      metholdKey: 'teacher',
      value: 'id',
      label: 'real_name',
      itemSpan: 12
    }
  },
  remark: {
    type: 'text',
    label: '备注信息',
    placeholder: '请填写备注信息',
    rules: [
      {
        message: '请填写备注信息',
        trigger: 'change'
      }
    ],
    options: {
      type: 'textarea',
      rows: 3
    }
  }
};
const formItemFun = (list = []) => {
  const allList = {};
  list.map(item => {
    if (formItems[item]) {
      allList[item] = formItems[item];
    }
    return [];
  });
  return allList;
};

export {
  newSannouncementItem,
  sysMessageFormItem,
  addContractFormItem,
  formItems,
  formItemFun,
  buildingFormItem,
  gradeFormItem,
  specialFormItem,
  discountFormItem,
  userFormItem,
  roomFormItem,
  teacherFormItem,
  teacherSearchFormItem,
  registerUserFormItem,
  registerUserSearchFormItem,
  registerUserRelationsFormItem,
  classInfFormItem,
  classInfCostFormItem,
  holidayFormItem,
  globalRecommendFormItem,
  globalClassTimeFormItem,
  globalOtherFormItem,
  enteredFormItem,
  teachBaseFormItem,
  newsFormItem,
  webFormItem,
  problemFormItem,
  contactFormItem,
  termFormItem,
  globalClassQueryFormItem,
  appVersionItem,
  substituteFormItem,
  substituteSearchFormItem,
  applyFormItem
};
